export default __webpack_public_path__ + "static/media/IconDesc_AluminiumScrap.256.fee6f3c9.png";